import {
		// Rankone,
		RankTwo
	} from '@/api/Rank.js'
export default {
	state:{
		ranktwo:[],
		rankstwo:[],
		// rankone:[]
	},
	mutations:{
		SET_RANKTWO(state,data){
			state.ranktwo = data
		},
		SET_RANKSTWO(state,data){
			state.rankstwo = data
		}
	},
	actions:{
		getRank(context){
			RankTwo({
				"r": "0.14644890952907907",
				"rankType": "3"
			})
			.then(res => {
				if (res.data.Code === 200) {
					context.commit('SET_RANKTWO',res.data.Data.DateCodeList)
					context.commit('SET_RANKSTWO',res.data.Data.Tags)
					console.log(context)
					// console.log(this.datecodelist)
				}
			})
		}
	},
	
}